export const ONBOARDING_STEPS = 3;
export const ONBOARDING = 'onboarding';
export const OnboardingStep = {
  CONNECT_DATA: 'connect_data',
  ANALYZE: 'analyze',
  CREATE_SMARTSLIDES: 'create_smartslides',
  INVITE_TEAM: 'invite_team',
  SHARE: 'share',
  DONE: 'done',
};

export const OnboardingEvent = {
  CONNECT_DATA: 'OnboardingEvent:connect_data',
  CREATE_DASHBOARD: 'OnboardingEvent:create_dashboard',
  CREATE_SMARTSLIDES: 'OnboardingEvent:create_smartslides',
  INVITE_TEAM: 'OnboardingEvent:invite_team',
  CREATE_REPORT: 'OnboardingEvent:create_report',
  ADDED_CREDIT_CARD: 'OnboardingEvent:added_credit_card',
  DASHBOARD_GENERATED: 'OnboardingEvent:dashboard_generated',
};

export const OnboardingTrendShape = {
  LINE: 'line',
  BARS: 'bars',
  SPIKES: 'spikes',
  GEO: 'geo',
  FUNNEL: 'funnel',
  COMPOSITE: 'composite',
};

export const OnboardingFlow = {
  AUTOPILOT: 'autopilot',
  CLASSIC: 'classic',
};

export const OnboardingQuestionStep = {
  GOAL: 'goal',
  NORTH_STAR: 'north_star',
  CONNECTORS: 'connectors',
};

export const OnboardingGoal = {
  EXECUTIVE_OVERVIEW: 'Executive overview',
  TRENDS_OVER_TIME: 'Trends over time',
  CHANNEL_CAMPAIGN_BREAKDOWN: 'Channel / campaign breakdown',
  TOP_PERFORMERS: 'Top performers',
  GEOGRAPHIC_PERFORMANCE: 'Geographic performance',
  CONVERSION_FUNNEL: 'Conversion funnel',
};

export const OnboardingKpi = {
  ROAS: 'ROAS',
  CPA: 'CPA',
  CONVERSION_RATE: 'Conversion Rate',
  REVENUE: 'Revenue',
  LEADS: 'Leads',
};

export const OnboardingDashboardBuildStatus = {
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  FAILED: 'failed',
};

export const OnboardingDashboardBuildFailureReason = {
  QUOTA: 'quota',
  UNSUPPORTED_CONNECTOR: 'unsupported_connector',
  BUILD_ERROR: 'build_error',
  TIMEOUT: 'timeout',
};

export const OnboardingConnector = {
  FACEBOOK_ADS: 'Facebook Ads',
  GOOGLE_ADS: 'Google Ads',
  GOOGLE_ANALYTICS_4: 'Google Analytics 4',
  FACEBOOK_INSIGHTS: 'Facebook Insights',
  LINKEDIN_ADS: 'LinkedIn Ads',
  GOOGLE_SEARCH_CONSOLE: 'Google Search Console',
  TIKTOK_ADS: 'TikTok Ads',
  MICROSOFT_ADVERTISING: 'Microsoft Advertising',
  GOOGLE_BUSINESS_PROFILE: 'Google Business Profile',
};

export const BOOK_DEMO_URL =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ15vowD1g7yNwfcV0R9wN3NRK1VZ7EapMW2Paebv0bMqBBws_eZU2m-10nB9SzXMLnp08JytEji?gv=true';

/** Indices into the autopilot build-step list; COMPLETE is one past the last step. */
export const AutopilotBuildStep = {
  UNDERSTAND: 0,
  PRIORITIZE: 1,
  CONNECT: 2,
  DISCOVER: 3,
  FETCH: 4,
  LAYOUT: 5,
  COMPLETE: 6,
};

export const OnboardingPathName = 'onboarding';
export const OnboardingClassicPathName = 'onboarding-classic';
